import { Component } from '@angular/core';
import { NavController } from '@ionic/angular';
import { FeedbackService } from '../../../services/feedback.service';
import { Contact } from '../../../models/contact';
import { ContactService } from '../../../services/contact.service';
import { marker as _ } from '@colsen1991/ngx-translate-extract-marker';
import { LoadingHelper } from "../../../utils/loading.helper";
import { Skill } from 'src/app/models/skill';

@Component({
    selector: 'app-feedback-pick-evaluator',
    templateUrl: './feedback-pick-evaluator.page.html',
    styleUrls: ['./feedback-pick-evaluator.page.scss'],
})
export class FeedbackPickEvaluatorPage {

    selectedContacts: Contact[] = [];
    disabled = false;
    skills: Skill[];
    loaded = false;
    skillId: number;

    constructor(
        private readonly feedbackService: FeedbackService,
        private readonly navCtrl: NavController,
        private readonly contactService: ContactService,
    ) { }

    ionViewWillEnter() {
        this.disabled = false;
        this.skills = this.feedbackService.requestFeedback?.skills || [];
        // If there is not skill, go back to /feedbacks/ask
        if (this.skills.length === 0) {
            this.navCtrl.navigateBack('/feedbacks/ask');
            return;
        }
        this.skillId = this.skills.length >= 2 ? null : this.skills[0].id;
        this.loaded = this.skills.length > 0;
        // Make sure there is no static loader
        LoadingHelper.close();
    }

    navigateBack() {
        this.navCtrl.back();
    }

    async submit() {
        this.disabled = true;
        // Check selected contacts
        const valid = await this.contactService.checkMinRequiredContacts(this.selectedContacts, this.skills);
        if (!valid) {
            this.disabled = false;
            return;
        }

        await LoadingHelper.open();
        // Send the feedbacks requests
        this.feedbackService.requestFeedback.contacts = this.selectedContacts;
        await this.navCtrl.navigateForward('/feedbacks/summary');
    }


}
